






















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Meeting } from "@api/models/meetings/Meeting";
import { Element } from "@api/models/Element";
import { UserProfile } from "@api/models/UserProfile";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";
import { WebConferenceRepository } from "@api/repositories/WebConferenceRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { StoreHelper } from "@share/web-conferences/helpers/StoreHelper";
import { GlobalEvents } from "@share/web-conferences/helpers/GlobalEvents";
import { WebConferenceStateHelper } from "@share/web-conferences/helpers/WebConferenceStateHelper";
import { SpeakerChecker } from "@share/web-conferences/helpers/SpeakerChecker";
import { DevicesInfo } from "@share/web-conferences/types/DevicesInfo";
import { sessionHasStopped, sessionStarted } from "@share/web-conferences/helpers/OnlineStateHelper";
import { isSchemaMeeting } from "@share/web-conferences/helpers/isSchemaMeeting";
import { fireInitializedEvent } from "@share/web-conferences/helpers/EventBusHelper";
import { RecordingStatusObserver } from "@share/web-conferences/signal-r/observers/RecordingStatusObserver";
import { ObserverData } from "@share/web-conferences/interfaces/signalr/ObserverData";
import { stateKey } from "@share/web-conferences/helpers/StateKey";
import DevicesTest from "@share/web-conferences/components/devices-test/DevicesTest.vue";
import { UserProfilesService } from "@share/web-conferences/data/UserProfilesService";
import { LiveKitClient } from "@share/live-kit/live-kit-classes/LiveKitClient";
import { LiveKitTracksManager } from "@share/live-kit/live-kit-classes/LiveKitTracksManager";
import { conferenceType } from "@share/web-conferences/helpers/ConferenceType";
import { LiveKitJoinHandler } from "@share/live-kit/live-kit-classes/LiveKitJoinHandler";
import { addJoinedUserAction, cleanWebConferenceAction } from "@share/web-conferences/store/actions";
import Connecting from "@share/web-conferences/components/Connecting.vue";
import CantJoin from "@share/web-conferences/components/CantJoin.vue";
import StoppedScreen from "@share/web-conferences/components/StoppedScreen.vue";
import Stage from "@share/live-kit/components/Stage.vue";
import { LiveKitRoomEventsHandler } from "@share/live-kit/live-kit-classes/LiveKitRoomEventsHandler";
import { LiveKitParticipantsEventsHandler } from "@share/live-kit/live-kit-classes/LiveKitParticipantsEventsHandler";
import { recordingStartedGetter } from "@share/web-conferences/store/getters";
import { sendRecordingNotification } from "@share/web-conferences/helpers/recordings/NotificationSender";
import { RecordingStatuses } from "@share/web-conferences/enums/RecordingStatuses";
import { isFinished } from "@common/webinarHelper";
import ControlPanel from "@share/live-kit/components/control-panel/ControlPanel.vue";
import { SchemaId } from "@api/enums/SchemaId";
import { LiveKitControlPanelController } from "@share/live-kit/controllers/LiveKitControlPanelController";
import { LiveKitShareController } from "@share/live-kit/controllers/LiveKitShareController";
import { SignalRHelper } from "@share/web-conferences/signal-r/SignalRHelper";
import { UserHandObserver } from "@share/web-conferences/signal-r/observers/UserHandObserver";
import { SignalRObserver } from "@share/web-conferences/interfaces/signalr/SignalRObserver";
import { CurrentPresentationUpdatedObserver } from "@share/live-kit/observers/CurrentPresentationUpdatedObserver";
import MediaLibrary from "@share/web-conferences/components/media-library/MediaLibrary.vue";
import { PresenterObserver } from "@share/live-kit/observers/PresenterObserver";
import { isPresenter } from "@share/web-conferences/helpers/UserRoleHelper";
import AutoplayError from "@share/web-conferences/components/AutoplayError.vue";
import { RecordingController } from "@share/web-conferences/helpers/RecordingController";
import { UserRoleType } from "@share/web-conferences/enums/UserRoleType";
import { StreamStatusChangeObserver } from "@share/live-kit/observers/StreamStatusChangeObserver";
import { LiveKitSpeakingController } from "@share/live-kit/controllers/LiveKitSpeakingController";
import { LiveKitQualityController } from "@share/live-kit/controllers/LiveKitQualityController";
import { ReconnectingController } from "@share/live-kit/controllers/ReconectingController";
import { ClientDataTypes } from "@share/live-kit/enums/ClientDataTypes";
import { LiveKitDataHelper } from "@share/live-kit/live-kit-classes/LiveKitDataHelper";
import { loggerInstance } from "@share/live-kit/logger";

@Component({
    name: "LiveKit",
    components: {AutoplayError, MediaLibrary, Stage, StoppedScreen, CantJoin, Connecting, DevicesTest, ControlPanel }
})
export default class LiveKit extends Vue {
    @Prop({ required: true }) schemaId: string;
    @Prop({ required: true }) element: Meeting | Element;
    @Prop({ default: () => [] }) speakers: UserProfile[];
    @Prop({ default: false }) hideControlPanel: boolean;
    @Prop() stateHelper: WebConferenceStateHelper;
    @Prop({ default: false }) showRecordingButton: boolean;

    webConferencesService: WebConferenceService | null = null;
    storeHelper: StoreHelper | null = null;
    globalEvents: GlobalEvents = new GlobalEvents();
    speakerChecker: SpeakerChecker | null = null;
    recordingStatusObserver: RecordingStatusObserver | null = null;
    observersData: ObserverData | null = null;
    userProfilesService: UserProfilesService | null = null;
    client: LiveKitClient | null = null;
    joinHandler: LiveKitJoinHandler | null = null;
    roomEventsHandler: LiveKitRoomEventsHandler | null = null;
    participantEventsHandler: LiveKitParticipantsEventsHandler | null = null;
    controlPanelController: LiveKitControlPanelController | null = null;
    shareController: LiveKitShareController | null = null;
    signalRHelper: SignalRHelper | null = null;
    recodingController: RecordingController | null = null;
    speakingController: LiveKitSpeakingController | null = null;
    qualityController: LiveKitQualityController | null = null;
    reconnectingController: ReconnectingController | null = null;
    liveKitDataHelper: LiveKitDataHelper | null = null;
    stateKey = '';

    get currentUserProfile(): UserProfile {
        return this.$store.getters.profile;
    }

    get isCurrentUserInSpeakersList() {
        return this.currentUserProfile && this.speakerChecker?.isInOriginalSpeakersList(this.currentUserProfile.userId as number);
    }

    get isAdmin() {
        return this.$store.getters.isAdmin;
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get tracks() {
        return this.client?.tracksManager.tracks ?? {};
    }

    get isReconnecting() {
        return this.reconnectingController?.isReconnecting;
        // return this.agoraConnectionState?.isReconnecting || this.connectionDropHandler?.isReconnecting;
    }

    get showControlPanel() {
        return Boolean(!this.stateHelper.left && this.client && this.client.joined && !this.hideControlPanel);
    }

    get needHandRaiseButton() {
        return this.schemaId !== SchemaId.meetingsSchedule
    }

    get needLiveSwitcher() {
        return this.schemaId === SchemaId.meetingsSchedule && this.isAdmin
    }

    get messages() {
        return loggerInstance.messages;
    }

    @Watch('element', {deep: true})
    onElementChange() {
        if (sessionHasStopped(this.element)) {
            this.stateHelper.stopped = true;

            if (this.webConferencesService?.webConferenceData?.userRole && !isPresenter(this.webConferencesService?.webConferenceData?.userRole)) {
                this.onLeave(false);
            }
            return;
        }

        if (sessionStarted(this.element)) {
            this.stateHelper.started = true;
            this.stateHelper.showEventInfo = false;

            if (!this.client?.joined && !this.stateHelper.connecting) {
                this.stateHelper.needDeviceTest = this.speakerChecker?.isSpeaker(this.currentUserProfile.userId as number) || false;
                if (!this.stateHelper.needDeviceTest) {
                    this.join();
                }
            }
            return;
        }
    }

    @Watch('stateHelper.banned')
    watchAgoraJoined(banned: boolean) {
        if(banned) {
            this.$emit('leave');
        }
    }

    async mounted() {
        await this.init();

        this.stateHelper.started = sessionStarted(this.element);
        this.stateHelper.stopped = sessionHasStopped(this.element);

        const isSpeaker = this.speakerChecker?.isSpeaker(this.currentUserProfile.userId as number);

        if (isSpeaker || this.isAdmin || this.stateHelper.isActive) {
            this.stateHelper.needDeviceTest = isSpeaker || false;
            if (!this.stateHelper.needDeviceTest) {
                await this.join();
            }

            this.recordingStatusObserver?.setShouldReact(true); //!isSchemaMeeting(this.schemaId)
        }
        else {
            this.stateHelper.showEventInfo = !this.stateHelper.stopped;
            this.stateHelper.left = this.stateHelper.stopped;
        }

        this.$emit('initialized', { userProfilesService: this.userProfilesService });

        fireInitializedEvent(this.schemaId, this.element.id);

        this.stateHelper.initialized = true;
    }

    async init() {
        this.storeHelper = new StoreHelper(this.$store, this.schemaId, this.element.id);
        this.stateKey = stateKey(this.schemaId, this.element.id);
        let webConferenceRepository = this.$repositories.get<WebConferenceRepository>(RepositoryFabric.WEB_CONFERENCE);
        this.webConferencesService = new WebConferenceService(
            webConferenceRepository,
            this.schemaId,
            this.element,
            this.storeHelper,
            this.globalEvents
        );
        this.userProfilesService = new UserProfilesService(this.$repositories.get(RepositoryFabric.USER));
        this.speakerChecker = new SpeakerChecker(this.storeHelper, this.speakers, this.schemaId, this.isAdmin, this.userId, this.$router, this.webConferencesService);
        this.client = new LiveKitClient(
            new LiveKitTracksManager(),
            conferenceType(this.schemaId),
            this.storeHelper
        );

        this.speakingController = new LiveKitSpeakingController();
        this.qualityController = new LiveKitQualityController(this.userId as number);
        this.participantEventsHandler = new LiveKitParticipantsEventsHandler(
            this.client, this.speakerChecker, this.userProfilesService,
            this.storeHelper, this.speakingController, this.qualityController,
            this.webConferencesService
        );

        this.joinHandler = new LiveKitJoinHandler(this.webConferencesService as WebConferenceService, this.client);

        this.reconnectingController = new ReconnectingController(this.joinHandler);
        this.roomEventsHandler = new LiveKitRoomEventsHandler(this.client, this.participantEventsHandler, this.reconnectingController);
        this.liveKitDataHelper = new LiveKitDataHelper(this.client, this.userProfilesService, this.storeHelper);

        this.shareController = new LiveKitShareController(this.webConferencesService, this.client, this.userId, this.storeHelper);
        this.controlPanelController = new LiveKitControlPanelController(this.shareController);
        this.recodingController = new RecordingController(this.schemaId, this.element, this.storeHelper, this.$repositories.get(RepositoryFabric.MEETING));
        this.recodingController.initShowRecordingButton(this.$router);

        this.observersData = {
            schemaId: this.schemaId,
            objectId: this.element.id,
            realtimeRepository: this.$repositories.get(RepositoryFabric.REALTIME),
            store: this.$store,
            stateKey: this.stateKey
        };

        this.recordingStatusObserver = new RecordingStatusObserver(this.observersData as ObserverData, this.recodingController, this.isAdmin);

        this.signalRHelper = new SignalRHelper(
            this.observersData,
            [
                new PresenterObserver(this.observersData, this.client, this.stateHelper, this.webConferencesService, this.storeHelper, this.participantEventsHandler),
                new UserHandObserver(this.observersData),
                new StreamStatusChangeObserver(this.observersData, this.client),
                this.recordingStatusObserver as SignalRObserver,
                new CurrentPresentationUpdatedObserver(this.observersData, this.webConferencesService, this.shareController)
            ]
        );

        this.storeHelper.setTracksManager(this.client.tracksManager);
    }

    async join() {
        if (this.stateHelper.connecting) {
            return;
        }

        this.stateHelper.showEventInfo = false;
        this.stateHelper.left = false;

        this.stateHelper.connecting = true;

        if (this.client?.joined) {
            await this.client.changeRoleToHost();
            //@todo think of a common event
            this.storeHelper?.addJoinedUser(parseInt(this.userId));

            // if (this.webConferencesService?.webConferenceData?.sharingCredentialsEmpty()) {
            //     await this.webConferencesService?.join();
            // }
        }
        else {
            loggerInstance.log('before join');
            await this.joinHandler?.join();

            const joinedSuccessfully = !this.joinHandler?.cantJoin && this.webConferencesService?.isWebConferenceDataNotEmpty();

            if (joinedSuccessfully) {
                if (this.recodingController) {
                    this.recodingController.isBeingRecorded = this.webConferencesService?.webConferenceData?.isBeginRecorded ?? false;
                }

                await this.signalRHelper?.connectToHub();
                
                this.userProfilesService?.setProfile(this.currentUserProfile);
                this.webConferencesService?.webConferenceData?.isPresenter() && await this.client?.createLocalTracks();
                this.$store.dispatch(addJoinedUserAction, {
                    userId: this.webConferencesService?.webConferenceData?.userId() as number,
                    key: this.stateKey
                })

                this.participantEventsHandler?.attachEventsToExisting();

                this.$emit("joined", true)
            }
            else {
                this.$emit("joined", false)
            }
        }

        if (this.client?.userRole == UserRoleType.Presenter) {
            await Promise.all([
                this.liveKitDataHelper?.publishData(ClientDataTypes.PresenterJoined),
                this.client.updateParticipant(this.client.room.localParticipant)
            ]);
        }

        this.stateHelper.connecting = false;
    }


    async onJoin(data: DevicesInfo) {
        this.stateHelper.stopDeviceTest();
        this.client?.setDevicesData(data);
        await this.join();
    }

    async onDecline() {
        this.stateHelper.stopDeviceTest();
        this.webConferencesService?.setNewRole(UserRoleType.Audience);
        //@todo check how removing from the presenters works when the backend is ready
        try {
            await this.webConferencesService?.webConferenceRepository
                .deletePresenter(this.schemaId, this.element.id, this.currentUserProfile.userId as number);
            if (!this.client?.joined) {
                await this.join();
            }
        }
        catch (e) {
            this.$store.dispatch('reportError', e);
        }
    }

    async onLeave(emitEvent = true) {
        // await this.agoraShareClient?.leave();
        await this.client?.leave();

        this.webConferencesService?.lowerHandIfRaised();

        this.stateHelper.left = true;

        if (this.webConferencesService?.webConferenceData?.isSharingUser(this.userId)) {
            await this.webConferencesService?.nullCurrentPresentation();
        }

        emitEvent && this.$emit('leave');
    }

    didSessionStop(): boolean {
        return sessionHasStopped(this.element) || isFinished(this.element.endAt);
    }

    async onSwitchMic(state: boolean) {
        await this.client?.switchMic(state);
    }

    async onSwitchVideo(state: boolean) {
        await this.client?.switchVideo(state);
    }

    async destroyed() {
        await this.onLeave();
        this.client?.clean();
        this.userProfilesService?.clean();
        this.globalEvents?.clean();
        await this.signalRHelper?.disconnectFromHub();
        this.speakingController?.clear();
        this.qualityController?.clear();
        // this.roomEventsHandler?.off();

        if (this.recordingStatusObserver?.shouldReact && this.$store.getters[recordingStartedGetter](this.stateKey) && this.didSessionStop()) {
            sendRecordingNotification(this.$store, RecordingStatuses.Ended);
        }

        if (this.webConferencesService?.webConferenceData?.isSharingUser(this.userId)) {
            await this.webConferencesService?.nullCurrentPresentation();
        }

        this.$store.dispatch(cleanWebConferenceAction, this.stateKey);
    }
}
